import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import { AbstractControl, FormArray, FormGroup } from "@angular/forms";
import {
  BokkzJrLogic,
  ClientEntity, Jaarrapportage,
  JaarrapportageEntity, Jaarrekening, LanglopendeSchuldenTekstueel,
  TrialBalanceItem
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from "rxjs";
import { SpecFormattedexplanationComponent } from '../spec-formattedexplanation/spec-formattedexplanation.component';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SpecTrialbalanceComponent } from '../spec-trialbalance/spec-trialbalance.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-langlopende-schulden',
  templateUrl: './spec-langlopende-schulden.component.html',
  imports: [
    SpecFormattedexplanationComponent,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SharedUiFormControlsModule,
    SpecTrialbalanceComponent,
    CommonModule
  ],
  styleUrls: ['./spec-langlopende-schulden.component.scss']
})
export class SpecLanglopendeSchuldenComponent implements OnInit,OnChanges,OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;

  public liabilitiesNoncurrentFg = {} as FormGroup;
  public convertibleBorrowingsNoncurrentFg = {} as FormGroup;
  public debenturesOtherPrivateLoansNoncurrentFg = {} as FormGroup;
  public financeLeaseLiabilitiesNoncurrentFg = {} as FormGroup;
  public payablesBanksNoncurrentFg = {} as FormGroup;
  public advancesReceivedNoncurrentFg = {} as FormGroup;
  public tradePayablesNoncurrentFg = {} as FormGroup;
  public billsExchangeChequesPayableNoncurrentFg = {} as FormGroup;
  public payablesGroupCompaniesNoncurrentFg = {} as FormGroup;
  public payablesOtherAffiliatedCompaniesNoncurrentFg = {} as FormGroup;
  public payablesShareholdersParticipatingInterestsNoncurrentFg = {} as FormGroup;
  public taxesSocialSecurityContributionsPayableNoncurrentFg = {} as FormGroup;
  public taxPayablesNoncurrentFg = {} as FormGroup;
  public pensionPayablesNoncurrentFg  = {} as FormGroup;
  public oldAgeObligationFg = {} as FormGroup;
  public negativeGoodwillFg = {} as FormGroup;
  public payablesOtherNoncurrentFg = {} as FormGroup;
  public accrualsAndDeferredIncomeNoncurrentFg = {} as FormGroup;

  public liabilitiesNoncurrentDisclosureFg = {} as FormGroup;
  public subordinatedLiabilitiesNoncurrentDisclosureFg = {} as FormGroup;
  public subordinatedLiabilitiesNoncurrentNatureDescriptionFg = {} as FormGroup;
  public convertibleBorrowingsNoncurrentDisclosureFg = {} as FormGroup
  public debenturesOtherPrivateLoansNoncurrentDisclosureFg = {} as FormGroup
  public financeLeaseLiabilitiesNoncurrentDisclosureFg = {} as FormGroup;
  public financeLeasesImportantConditionsFg = {} as FormGroup
  public mainPurposeFinancialLeaseLessorDescriptionFg = {} as FormGroup
  public legalPersonNotALegalOwnerDescriptionFg = {} as FormGroup
  public advancesReceivedNoncurrentDisclosureFg = {} as FormGroup
  public tradePayablesNoncurrentDisclosureFg = {} as FormGroup
  public billsExchangeChequesPayableNoncurrentDisclosureFg = {} as FormGroup
  public payablesBanksNoncurrentDisclosureFg = {} as FormGroup;
  public payablesGroupCompaniesNoncurrentDisclosureFg = {} as FormGroup;
  public payablesShareholdersParticipatingInterestsNoncurrentDisclosureFg = {} as FormGroup
  public payablesOtherAffiliatedCompaniesNoncurrentDisclosureFg = {} as FormGroup;
  public taxesSocialSecurityContributionsPayableNoncurrentDisclosureFg = {} as FormGroup
  public taxPayablesNoncurrentDisclosureFg = {} as FormGroup
  public pensionPayablesNoncurrentDisclosureFg = {} as FormGroup
  public oldAgeObligationDisclosureFg = {} as FormGroup;
  public negativeGoodwillDisclosureFg = {} as FormGroup
  public negativeGoodwillFutureLossesDescriptionFg = {} as FormGroup
  public negativeGoodwillIncomeStatementLineItemWhereRecognisedDescriptionFg = {} as FormGroup
  public negativeGoodwillRecognitionPeriodIncomeStatementDescriptionFg = {} as FormGroup
  public payablesOtherNoncurrentDisclosureFg = {} as FormGroup;
  public accrualsAndDeferredIncomeNoncurrentDisclosureFg = {} as FormGroup
  public liabilitiesSecuredStatementFg = {} as FormGroup
  public formCollateralProvidedTotalDebtsDescriptionFg = {} as FormGroup
  public liabilitiesNoncurrentMaturityDisclosureFg = {} as FormGroup
  public liabilitiesMaturityInterestRateDescriptionFg = {} as FormGroup
  public liabilitiesNoncurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosureFg = {} as FormGroup

  public effectiveInterestRateOnLongtermDebtDisclosureFg                                                                                                               = {} as FormGroup
  public liabilitiesNoncurrentImmediateExigibilityDescriptionFg                                                                                                        = {} as FormGroup
  public bankCovenantNotEnteredIntoForceOnBalanceSheetDateOrAfterBalanceSheetDateBeforeFinancialStatementsAreDrawnUpButHasBeenApproachedCloselyDescriptionFg           = {} as FormGroup
  public moneyOrSharesRedeemableLoansConditionsConversionFg                                                                                                            = {} as FormGroup
  public sharesRedeemableLoansConditionsConversionFg                                                                                                                   = {} as FormGroup
  public warrantsAndWarrantsLoansConditionsConversionFg                                                                                                                = {} as FormGroup
  public convertibleBorrowingsConditionsConversionFg                                                                                                                   = {} as FormGroup
  public indicationNatureDependenceAndFactorsNonFixedInterestRateDescriptionFg                                                                                         = {} as FormGroup
  public progressionInterestRateInconsistentInterestRateRemainingMaturityDescriptionFg                                                                                 = {} as FormGroup

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    private jrLogicService: BokkzJrLogic,
    public jrDataService: BokkzJrDataService) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });

    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.convertibleBorrowingsNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.debenturesOtherPrivateLoansNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.financeLeaseLiabilitiesNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.payablesBanksNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.advancesReceivedNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.tradePayablesNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.billsExchangeChequesPayableNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.payablesGroupCompaniesNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.payablesOtherAffiliatedCompaniesNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.payablesShareholdersParticipatingInterestsNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.taxesSocialSecurityContributionsPayableNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.taxPayablesNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.pensionPayablesNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.oldAgeObligationFg = this.jrDataService.createFormGroupBalanceItem();
    this.negativeGoodwillFg = this.jrDataService.createFormGroupBalanceItem();
    this.payablesOtherNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();
    this.accrualsAndDeferredIncomeNoncurrentFg = this.jrDataService.createFormGroupBalanceItem();

    this.liabilitiesNoncurrentFg = this.jrDataService.createFormGroupMonetaryNoDecimalsPeriodValues();

    this.liabilitiesNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.subordinatedLiabilitiesNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.subordinatedLiabilitiesNoncurrentNatureDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.convertibleBorrowingsNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.debenturesOtherPrivateLoansNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.financeLeaseLiabilitiesNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.payablesBanksNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.advancesReceivedNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.tradePayablesNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.billsExchangeChequesPayableNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.payablesGroupCompaniesNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.payablesShareholdersParticipatingInterestsNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.payablesOtherAffiliatedCompaniesNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.taxesSocialSecurityContributionsPayableNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.taxPayablesNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.pensionPayablesNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.oldAgeObligationDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.negativeGoodwillDisclosureFg  = this.jrDataService.createFormGroupFormattedExplanation()
    this.negativeGoodwillFutureLossesDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation()
    this.negativeGoodwillIncomeStatementLineItemWhereRecognisedDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation()
    this.negativeGoodwillRecognitionPeriodIncomeStatementDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation()
    this.payablesOtherNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.accrualsAndDeferredIncomeNoncurrentDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation()
    this.liabilitiesSecuredStatementFg = this.jrDataService.createFormGroupFormattedExplanation()
    this.formCollateralProvidedTotalDebtsDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.liabilitiesNoncurrentMaturityDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation()
    this.liabilitiesMaturityInterestRateDescriptionFg = this.jrDataService.createFormGroupFormattedExplanation()
    this.liabilitiesNoncurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation()

    this.effectiveInterestRateOnLongtermDebtDisclosureFg                                                                                                     =this.jrDataService.createFormGroupFormattedExplanation()
    this.liabilitiesNoncurrentImmediateExigibilityDescriptionFg                                                                                              =this.jrDataService.createFormGroupFormattedExplanation()
    this.bankCovenantNotEnteredIntoForceOnBalanceSheetDateOrAfterBalanceSheetDateBeforeFinancialStatementsAreDrawnUpButHasBeenApproachedCloselyDescriptionFg =this.jrDataService.createFormGroupFormattedExplanation()
    this.moneyOrSharesRedeemableLoansConditionsConversionFg                                                                                                  =this.jrDataService.createFormGroupFormattedExplanation()
    this.sharesRedeemableLoansConditionsConversionFg                                                                                                         =this.jrDataService.createFormGroupFormattedExplanation()
    this.warrantsAndWarrantsLoansConditionsConversionFg                                                                                                      =this.jrDataService.createFormGroupFormattedExplanation()
    this.convertibleBorrowingsConditionsConversionFg                                                                                                         =this.jrDataService.createFormGroupFormattedExplanation()
    this.indicationNatureDependenceAndFactorsNonFixedInterestRateDescriptionFg                                                                               =this.jrDataService.createFormGroupFormattedExplanation()
    this.progressionInterestRateInconsistentInterestRateRemainingMaturityDescriptionFg                                                                       =this.jrDataService.createFormGroupFormattedExplanation()
    this.financeLeasesImportantConditionsFg                                                                                                                  =this.jrDataService.createFormGroupFormattedExplanation()
    this.mainPurposeFinancialLeaseLessorDescriptionFg                                                                                                        =this.jrDataService.createFormGroupFormattedExplanation()
    this.legalPersonNotALegalOwnerDescriptionFg                                                                                                              =this.jrDataService.createFormGroupFormattedExplanation()
  }

  private patchData(value: JaarrapportageEntity) {
    const langlopendeSchulden = value.rapportage?.jaarrekeningen?.at(0)?.balans?.langlopendeSchulden;

    if (langlopendeSchulden) {
      this.liabilitiesNoncurrentFg.reset();

      if (langlopendeSchulden.liabilitiesNoncurrent) {
        this.liabilitiesNoncurrentFg.patchValue(langlopendeSchulden.liabilitiesNoncurrent, {emitEvent: false})
      }

      const uitsplitsing = langlopendeSchulden.langlopendeSchuldenUitsplitsing;
      const tekstueel = langlopendeSchulden.langlopendeSchuldenTekstueel;

      if (uitsplitsing) {
        if (uitsplitsing?.convertibleBorrowingsNoncurrent) {
          const subItem = uitsplitsing.convertibleBorrowingsNoncurrent;
          this.convertibleBorrowingsNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.convertibleBorrowingsNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.debenturesOtherPrivateLoansNoncurrent) {
          const subItem = uitsplitsing.debenturesOtherPrivateLoansNoncurrent;
          this.debenturesOtherPrivateLoansNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.debenturesOtherPrivateLoansNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.financeLeaseLiabilitiesNoncurrent) {
          const subItem = uitsplitsing.financeLeaseLiabilitiesNoncurrent;
          this.financeLeaseLiabilitiesNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.financeLeaseLiabilitiesNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.payablesBanksNoncurrent) {
          const subItem = uitsplitsing.payablesBanksNoncurrent;
          this.payablesBanksNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.payablesBanksNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.advancesReceivedNoncurrent) {
          const subItem = uitsplitsing.advancesReceivedNoncurrent;
          this.advancesReceivedNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.advancesReceivedNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.tradePayablesNoncurrent) {
          const subItem = uitsplitsing.tradePayablesNoncurrent;
          this.tradePayablesNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.tradePayablesNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.billsExchangeChequesPayableNoncurrent) {
          const subItem = uitsplitsing.billsExchangeChequesPayableNoncurrent;
          this.billsExchangeChequesPayableNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.billsExchangeChequesPayableNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.payablesGroupCompaniesNoncurrent) {
          const subItem = uitsplitsing.payablesGroupCompaniesNoncurrent;
          this.payablesGroupCompaniesNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.payablesGroupCompaniesNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.payablesOtherAffiliatedCompaniesNoncurrent) {
          const subItem = uitsplitsing.payablesOtherAffiliatedCompaniesNoncurrent;
          this.payablesOtherAffiliatedCompaniesNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.payablesOtherAffiliatedCompaniesNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.payablesShareholdersParticipatingInterestsNoncurrent) {
          const subItem = uitsplitsing.payablesShareholdersParticipatingInterestsNoncurrent;
          this.payablesShareholdersParticipatingInterestsNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.payablesShareholdersParticipatingInterestsNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.taxesSocialSecurityContributionsPayableNoncurrent) {
          const subItem = uitsplitsing.taxesSocialSecurityContributionsPayableNoncurrent;
          this.taxesSocialSecurityContributionsPayableNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.taxesSocialSecurityContributionsPayableNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.taxPayablesNoncurrent) {
          const subItem = uitsplitsing.taxPayablesNoncurrent;
          this.taxPayablesNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.taxPayablesNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.pensionPayablesNoncurrent) {
          const subItem = uitsplitsing.pensionPayablesNoncurrent;
          this.pensionPayablesNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.pensionPayablesNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.oldAgeObligation) {
          const subItem = uitsplitsing.oldAgeObligation;
          this.oldAgeObligationFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.oldAgeObligationFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.negativeGoodwill) {
          const subItem = uitsplitsing.negativeGoodwill;
          this.negativeGoodwillFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.negativeGoodwillFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.payablesOtherNoncurrent) {
          const subItem = uitsplitsing.payablesOtherNoncurrent;
          this.payablesOtherNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.payablesOtherNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing?.accrualsAndDeferredIncomeNoncurrent) {
          const subItem = uitsplitsing.accrualsAndDeferredIncomeNoncurrent;
          this.accrualsAndDeferredIncomeNoncurrentFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.accrualsAndDeferredIncomeNoncurrentFg.get('trialBalanceItems') as FormArray)
        }
      }

      if (tekstueel) {
        this.vulTextData(tekstueel)
      }
    }
  }

  updateTrialBalanceItems(lijst?: TrialBalanceItem[], formArray?: FormArray) {
    if (lijst && formArray) {
      for (let i = 0; i < lijst.length; i++) {
        if (i < formArray.length) {
          const control = formArray.at(i) as FormGroup;
          control.patchValue(lijst[i]);
        } else {
          const formGroup = this.jrDataService.createFormGroupTrialBalanceItem(lijst[i])
          formArray.push(formGroup);
        }
      }
    }
  }

  saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    this.liabilitiesNoncurrentFg.updateValueAndValidity();
    this.convertibleBorrowingsNoncurrentFg.updateValueAndValidity();
    this.debenturesOtherPrivateLoansNoncurrentFg.updateValueAndValidity();
    this.financeLeaseLiabilitiesNoncurrentFg.updateValueAndValidity();
    this.payablesBanksNoncurrentFg.updateValueAndValidity();
    this.advancesReceivedNoncurrentFg.updateValueAndValidity();
    this.tradePayablesNoncurrentFg.updateValueAndValidity();
    this.billsExchangeChequesPayableNoncurrentFg.updateValueAndValidity();
    this.payablesGroupCompaniesNoncurrentFg.updateValueAndValidity();
    this.payablesOtherAffiliatedCompaniesNoncurrentFg.updateValueAndValidity();
    this.payablesShareholdersParticipatingInterestsNoncurrentFg.updateValueAndValidity();
    this.taxesSocialSecurityContributionsPayableNoncurrentFg.updateValueAndValidity();
    this.taxPayablesNoncurrentFg.updateValueAndValidity();
    this.pensionPayablesNoncurrentFg.updateValueAndValidity();
    this.oldAgeObligationFg.updateValueAndValidity();
    this.negativeGoodwillFg.updateValueAndValidity();
    this.payablesOtherNoncurrentFg.updateValueAndValidity();
    this.accrualsAndDeferredIncomeNoncurrentFg.updateValueAndValidity();

    this.liabilitiesNoncurrentDisclosureFg.updateValueAndValidity();
    this.subordinatedLiabilitiesNoncurrentDisclosureFg.updateValueAndValidity();
    this.subordinatedLiabilitiesNoncurrentNatureDescriptionFg.updateValueAndValidity();
    this.convertibleBorrowingsNoncurrentDisclosureFg.updateValueAndValidity();
    this.debenturesOtherPrivateLoansNoncurrentDisclosureFg.updateValueAndValidity();
    this.financeLeaseLiabilitiesNoncurrentDisclosureFg.updateValueAndValidity();
    this.payablesBanksNoncurrentDisclosureFg.updateValueAndValidity();
    this.advancesReceivedNoncurrentDisclosureFg.updateValueAndValidity();
    this.tradePayablesNoncurrentDisclosureFg.updateValueAndValidity();
    this.billsExchangeChequesPayableNoncurrentDisclosureFg.updateValueAndValidity();
    this.payablesGroupCompaniesNoncurrentDisclosureFg.updateValueAndValidity();
    this.payablesShareholdersParticipatingInterestsNoncurrentDisclosureFg.updateValueAndValidity();
    this.payablesOtherAffiliatedCompaniesNoncurrentDisclosureFg.updateValueAndValidity();
    this.taxesSocialSecurityContributionsPayableNoncurrentDisclosureFg.updateValueAndValidity();
    this.taxPayablesNoncurrentDisclosureFg.updateValueAndValidity();
    this.pensionPayablesNoncurrentDisclosureFg.updateValueAndValidity();
    this.oldAgeObligationDisclosureFg.updateValueAndValidity();
    this.negativeGoodwillDisclosureFg.updateValueAndValidity();
    this.negativeGoodwillFutureLossesDescriptionFg.updateValueAndValidity();
    this.negativeGoodwillIncomeStatementLineItemWhereRecognisedDescriptionFg.updateValueAndValidity();
    this.negativeGoodwillRecognitionPeriodIncomeStatementDescriptionFg.updateValueAndValidity();
    this.payablesOtherNoncurrentDisclosureFg.updateValueAndValidity();
    this.accrualsAndDeferredIncomeNoncurrentDisclosureFg.updateValueAndValidity();
    this.liabilitiesSecuredStatementFg.updateValueAndValidity();
    this.formCollateralProvidedTotalDebtsDescriptionFg.updateValueAndValidity();
    this.liabilitiesNoncurrentMaturityDisclosureFg.updateValueAndValidity();
    this.liabilitiesMaturityInterestRateDescriptionFg.updateValueAndValidity();
    this.liabilitiesNoncurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosureFg.updateValueAndValidity();

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        balans: {
          ...this.jrEntity.rapportage.jaarrekeningen[0].balans,
          langlopendeSchulden: {
            ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.langlopendeSchulden,
            langlopendeSchuldenUitsplitsing: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.langlopendeSchulden?.langlopendeSchuldenUitsplitsing,
              convertibleBorrowingsNoncurrent: this.convertibleBorrowingsNoncurrentFg.value,
              debenturesOtherPrivateLoansNoncurrent: this.debenturesOtherPrivateLoansNoncurrentFg.value,
              financeLeaseLiabilitiesNoncurrent: this.financeLeaseLiabilitiesNoncurrentFg.value,
              payablesBanksNoncurrent: this.payablesBanksNoncurrentFg.value,
              advancesReceivedNoncurrent: this.advancesReceivedNoncurrentFg.value,
              tradePayablesNoncurrent: this.tradePayablesNoncurrentFg.value,
              billsExchangeChequesPayableNoncurrent: this.billsExchangeChequesPayableNoncurrentFg.value,
              payablesGroupCompaniesNoncurrent: this.payablesGroupCompaniesNoncurrentFg.value,
              payablesOtherAffiliatedCompaniesNoncurrent: this.payablesOtherAffiliatedCompaniesNoncurrentFg.value,
              payablesShareholdersParticipatingInterestsNoncurrent: this.payablesShareholdersParticipatingInterestsNoncurrentFg.value,
              taxesSocialSecurityContributionsPayableNoncurrent: this.taxesSocialSecurityContributionsPayableNoncurrentFg.value,
              taxPayablesNoncurrent: this.taxPayablesNoncurrentFg.value,
              pensionPayablesNoncurrent: this.pensionPayablesNoncurrentFg.value,
              oldAgeObligation: this.oldAgeObligationFg.value,
              negativeGoodwill: this.negativeGoodwillFg.value,
              payablesOtherNoncurrent: this.payablesOtherNoncurrentFg.value,
              accrualsAndDeferredIncomeNoncurrent: this.accrualsAndDeferredIncomeNoncurrentFg.value,
            },
            langlopendeSchuldenTekstueel: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].balans?.langlopendeSchulden?.langlopendeSchuldenTekstueel,
              liabilitiesNoncurrentDisclosure: this.liabilitiesNoncurrentDisclosureFg.value,
              subordinatedLiabilitiesNoncurrentDisclosure: this.subordinatedLiabilitiesNoncurrentDisclosureFg.value,
              subordinatedLiabilitiesNoncurrentNatureDescription: this.subordinatedLiabilitiesNoncurrentNatureDescriptionFg.value,
              convertibleBorrowingsNoncurrentDisclosure: this.convertibleBorrowingsNoncurrentDisclosureFg.value,
              debenturesOtherPrivateLoansNoncurrentDisclosure: this.debenturesOtherPrivateLoansNoncurrentDisclosureFg.value,
              financeLeaseLiabilitiesNoncurrentDisclosure: this.financeLeaseLiabilitiesNoncurrentDisclosureFg.value,
              payablesBanksNoncurrentDisclosure: this.payablesBanksNoncurrentDisclosureFg.value,
              advancesReceivedNoncurrentDisclosure: this.advancesReceivedNoncurrentDisclosureFg.value,
              tradePayablesNoncurrentDisclosure: this.tradePayablesNoncurrentDisclosureFg.value,
              billsExchangeChequesPayableNoncurrentDisclosure: this.billsExchangeChequesPayableNoncurrentDisclosureFg.value,
              payablesGroupCompaniesNoncurrentDisclosure: this.payablesGroupCompaniesNoncurrentDisclosureFg.value,
              payablesShareholdersParticipatingInterestsNoncurrentDisclosure: this.payablesShareholdersParticipatingInterestsNoncurrentDisclosureFg.value,
              payablesOtherAffiliatedCompaniesNoncurrentDisclosure: this.payablesOtherAffiliatedCompaniesNoncurrentDisclosureFg.value,
              taxesSocialSecurityContributionsPayableNoncurrentDisclosure: this.taxesSocialSecurityContributionsPayableNoncurrentDisclosureFg.value,
              taxPayablesNoncurrentDisclosure: this.taxPayablesNoncurrentDisclosureFg.value,
              pensionPayablesNoncurrentDisclosure: this.pensionPayablesNoncurrentDisclosureFg.value,
              oldAgeObligationDisclosure: this.oldAgeObligationDisclosureFg.value,
              negativeGoodwillDisclosure: this.negativeGoodwillDisclosureFg.value,
              negativeGoodwillFutureLossesDescription: this.negativeGoodwillFutureLossesDescriptionFg.value,
              negativeGoodwillIncomeStatementLineItemWhereRecognisedDescription: this.negativeGoodwillIncomeStatementLineItemWhereRecognisedDescriptionFg.value,
              negativeGoodwillRecognitionPeriodIncomeStatementDescription: this.negativeGoodwillRecognitionPeriodIncomeStatementDescriptionFg.value,
              payablesOtherNoncurrentDisclosure: this.payablesOtherNoncurrentDisclosureFg.value,
              accrualsAndDeferredIncomeNoncurrentDisclosure: this.accrualsAndDeferredIncomeNoncurrentDisclosureFg.value,
              liabilitiesSecuredStatement: this.liabilitiesSecuredStatementFg.value,
              formCollateralProvidedTotalDebtsDescription: this.formCollateralProvidedTotalDebtsDescriptionFg.value,
              liabilitiesNoncurrentMaturityDisclosure: this.liabilitiesNoncurrentMaturityDisclosureFg.value,
              liabilitiesMaturityInterestRateDescription: this.liabilitiesMaturityInterestRateDescriptionFg.value,
              liabilitiesNoncurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosure: this.liabilitiesNoncurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosureFg.value,
            }
          }
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
    this.jrLogicService.getCalculation(this.jrEntity)
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });
  }

  vulTextData(tekstueel: LanglopendeSchuldenTekstueel) {
      const tekstueelFieldMapping: Partial<Record<keyof LanglopendeSchuldenTekstueel, AbstractControl>> = {
        liabilitiesNoncurrentDisclosure: this.liabilitiesNoncurrentDisclosureFg,
        subordinatedLiabilitiesNoncurrentDisclosure: this.subordinatedLiabilitiesNoncurrentDisclosureFg,
        subordinatedLiabilitiesNoncurrentNatureDescription: this.subordinatedLiabilitiesNoncurrentNatureDescriptionFg,
        convertibleBorrowingsNoncurrentDisclosure: this.convertibleBorrowingsNoncurrentDisclosureFg,
        debenturesOtherPrivateLoansNoncurrentDisclosure: this.debenturesOtherPrivateLoansNoncurrentDisclosureFg,
        financeLeaseLiabilitiesNoncurrentDisclosure: this.financeLeaseLiabilitiesNoncurrentDisclosureFg,
        payablesBanksNoncurrentDisclosure: this.payablesBanksNoncurrentDisclosureFg,
        advancesReceivedNoncurrentDisclosure: this.advancesReceivedNoncurrentDisclosureFg,
        tradePayablesNoncurrentDisclosure: this.tradePayablesNoncurrentDisclosureFg,
        billsExchangeChequesPayableNoncurrentDisclosure: this.billsExchangeChequesPayableNoncurrentDisclosureFg,
        payablesGroupCompaniesNoncurrentDisclosure: this.payablesGroupCompaniesNoncurrentDisclosureFg,
        payablesShareholdersParticipatingInterestsNoncurrentDisclosure: this.payablesShareholdersParticipatingInterestsNoncurrentDisclosureFg,
        payablesOtherAffiliatedCompaniesNoncurrentDisclosure: this.payablesOtherAffiliatedCompaniesNoncurrentDisclosureFg,
        taxesSocialSecurityContributionsPayableNoncurrentDisclosure: this.taxesSocialSecurityContributionsPayableNoncurrentDisclosureFg,
        taxPayablesNoncurrentDisclosure: this.taxPayablesNoncurrentDisclosureFg,
        pensionPayablesNoncurrentDisclosure: this.pensionPayablesNoncurrentDisclosureFg,
        oldAgeObligationDisclosure: this.oldAgeObligationDisclosureFg,
        negativeGoodwillDisclosure: this.negativeGoodwillDisclosureFg,
        negativeGoodwillFutureLossesDescription: this.negativeGoodwillFutureLossesDescriptionFg,
        negativeGoodwillIncomeStatementLineItemWhereRecognisedDescription: this.negativeGoodwillIncomeStatementLineItemWhereRecognisedDescriptionFg,
        negativeGoodwillRecognitionPeriodIncomeStatementDescription: this.negativeGoodwillRecognitionPeriodIncomeStatementDescriptionFg,
        payablesOtherNoncurrentDisclosure: this.payablesOtherNoncurrentDisclosureFg,
        accrualsAndDeferredIncomeNoncurrentDisclosure: this.accrualsAndDeferredIncomeNoncurrentDisclosureFg,
        liabilitiesSecuredStatement: this.liabilitiesSecuredStatementFg,
        liabilitiesNoncurrentMaturityDisclosure: this.liabilitiesNoncurrentMaturityDisclosureFg,
        liabilitiesMaturityInterestRateDescription: this.liabilitiesMaturityInterestRateDescriptionFg,
        liabilitiesNoncurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosure: this.liabilitiesNoncurrentToWhichTheLegalPersonHasCommittedItselfToEncumberAssetsDisclosureFg,
        formCollateralProvidedTotalDebtsDescription: this.formCollateralProvidedTotalDebtsDescriptionFg,
        effectiveInterestRateOnLongtermDebtDisclosure: this.effectiveInterestRateOnLongtermDebtDisclosureFg,
        liabilitiesNoncurrentImmediateExigibilityDescription: this.liabilitiesNoncurrentImmediateExigibilityDescriptionFg,
        bankCovenantNotEnteredIntoForceOnBalanceSheetDateOrAfterBalanceSheetDateBeforeFinancialStatementsAreDrawnUpButHasBeenApproachedCloselyDescription: this.bankCovenantNotEnteredIntoForceOnBalanceSheetDateOrAfterBalanceSheetDateBeforeFinancialStatementsAreDrawnUpButHasBeenApproachedCloselyDescriptionFg,
        moneyOrSharesRedeemableLoansConditionsConversion: this.moneyOrSharesRedeemableLoansConditionsConversionFg,
        sharesRedeemableLoansConditionsConversion: this.sharesRedeemableLoansConditionsConversionFg,
        warrantsAndWarrantsLoansConditionsConversion: this.warrantsAndWarrantsLoansConditionsConversionFg,
        convertibleBorrowingsConditionsConversion: this.convertibleBorrowingsConditionsConversionFg,
        indicationNatureDependenceAndFactorsNonFixedInterestRateDescription: this.indicationNatureDependenceAndFactorsNonFixedInterestRateDescriptionFg,
        progressionInterestRateInconsistentInterestRateRemainingMaturityDescription: this.progressionInterestRateInconsistentInterestRateRemainingMaturityDescriptionFg,
        financeLeasesImportantConditions                   :       this.financeLeasesImportantConditionsFg                                            ,
        mainPurposeFinancialLeaseLessorDescription         :       this.mainPurposeFinancialLeaseLessorDescriptionFg                                  ,
        legalPersonNotALegalOwnerDescription               :       this.legalPersonNotALegalOwnerDescriptionFg                                        ,
      };

      for (const key in tekstueelFieldMapping) {
        const control = tekstueelFieldMapping[key as keyof LanglopendeSchuldenTekstueel];
        const value = tekstueel[key as keyof LanglopendeSchuldenTekstueel];
        if (control && value !== undefined && value !== null) {
          control.patchValue(value);
        }
      }
    }

}
